import React from 'react'
import GmsTola from '../../../components/homeComponents/GmsTola'
import RecentNews from '../../../shared/Gallery'
import GoToTop from '../../../Scroll/GoToTop'
import { Container } from '../../../components/Container'

const Introduction = () => {
  return (
    <Container>
    <GmsTola />
    <div className='mx-[20px] md:mx-[10px] font-poppins mt-[20px] mb-[30px] '>
      <h1 className=' border-b-[1px] border-blue-gray-300 mb-[15px]'>संस्थाको परित्तरा
      </h1>
     <p className='text-start'>
     सुनचाँदी व्यवसाय सम्बन्धी व्यवहारिक कारोवार आवश्यकता अनुसार समय सापेक्ष ढङ्गले अघि बढाउन र व्यवसायीहरुको हक, हित र अधिकार सुरक्षित गर्न २०४४/११/०८ गते नेपाल सुनचाँदी व्यवसायी संघ, केन्द्रीय कार्यालय स्थापना भएको थियो । तत्पश्चात संघबाट विभिन्न प्रकारका समस्याहरु सामना गरि रहेको विसंगतिहरुका बारेमा सम्बन्धित निकाय समक्ष आवाज राखी आएको थियो । त्यहि दौरानमा यसलाई अझ मजबुत गर्न विभिन्न जिल्लाहरुमा शाखा विस्तार गरे जस्तै काठमाडौमा पनि यसको छुटै शाखाको आवश्यकता महसुश गरी केन्द्रीय कार्यालयको निर्देशनमा २०५८/०५/०९ गते काठमाडौमा विशेष भेला गरि उक्त विशेष भेलामा तत्कालिन नेपाल सुनचाँदी व्यवसायी संघको संस्थापक सदस्य स्व श्री जुजुभाई शाक्यज्यूको विशेष पहलमा तत्कालिन सह-सचिव श्री चैनकाजी शाक्यज्यूको संयोजकत्वमा ११ जनाको काठमाडौं शाखाको तदर्थ समिति गठन भएको थियो । पछि त्यहि समितिबाट श्री हेमबज शाक्यज्यूको अध्यक्षतामा २०५८/०९/०७ गते काठमाडौं शाखाको विधिवत रुपमा स्थापना भई यस संघको उद्देश्य अनुरुप कार्य गर्दै आईरहेको छ ।
     </p>

     <p className='text-start'>
     २०५८ सालदेखि नेपाल सुनचाँदी व्यवसायी संघ, काठमाडौ शाखाको रुपमा संचालन हुँदै आएकोमा महासंघको अवधारण अनुरुप संस्थाको स्तरउन्नत्ती र रुपान्तरण गर्दै काठमाडौ सुनचाँदी व्यवसायी संघ नामाकरण गरी व्यवसाय र व्यवसायीहरु बिचको स्वतन्त्र गैर सरकारी संस्था स्थापना गरि संचालन गर्न मिति २०६९/१०/०६ गते शनिबार स्वयम्भु स्थलमा बसेको यस संस्थाको दशौ वार्षिक साधारण सभाबाट विशेष प्रस्ताव पारित गरि त्यस पश्चात गठन गरिएको तदर्थ समितिको पूर्ण बैठकबाट मिति २०६९/१०/२० गतेबाट सर्वसहमतीका साथ निर्णय गरी काठमाडी सुनचाँदी व्यवसायी सघ विधिपूर्वक मिति २०६९/११/१० गते विभिन्न सरकारी कार्यालयहरुमा कर छुट र स्वतन्त्र विधान सहित दर्ता गरि संचालनमा आई रहेको छ ।
     </p>
    </div>
     <RecentNews />
     <GoToTop />
    </Container>
  )
}

export default Introduction